export default "__VITE_ASSET__DOD3M3rN__"